import type { RouteObject } from 'react-router';

import { Navigate } from 'react-router';

import lazyWithReload from 'src/utils/lazyWithReload';

import { CONFIG } from 'src/global-config';
import { chatRoutes } from 'src/pages/chat/routes/chat';
import { csatRoutes } from 'src/pages/csat/routes/csat';
import { reportRoutes } from 'src/pages/reports/routes/report';
import { ticketRoutes } from 'src/pages/tickets/routes/ticket';
import { profileRoutes } from 'src/pages/setting/routes/profile';
import { settingRoutes } from 'src/pages/setting/routes/setting';
import { channelRoutes } from 'src/pages/channel/routes/channel';
import { accountRoutes } from 'src/pages/accounts/routes/account';
import { contactRoutes } from 'src/pages/contacts/routes/contact';
import { campaignRoutes } from 'src/pages/campaign/routes/campaign';
import { dashboardRoutes } from 'src/pages/dashborad/routes/dashboard';
import { automationRoutes } from 'src/pages/automation/routes/automation';
import { PermissionWrapper } from 'src/pages/auth/hooks/permissionWrapper';
import { withModulePermission } from 'src/pages/auth/hooks/withModulePermission';
import PaymentCallback from 'src/pages/setting/components/billing/features/payment/payment-callback';

import { AuthGuard } from 'src/auth/guard';

import { authRoutes } from '../../pages/auth/routes/auth';
import { tenantRoutes } from '../../pages/tenants/routes/tenant';

// ----------------------------------------------------------------------

const Page404 = lazyWithReload(() => import('src/pages/error/404'));
const Page403 = lazyWithReload(() => import('src/pages/error/403'));
const PolicyPage = lazyWithReload(() => import('src/pages/policy/policy'));
const CalendarSuccess = lazyWithReload(
  () => import('src/pages/setting/components/calendar/components/calendar-success')
);

export const routesSection: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to={CONFIG.auth.redirectPath} replace />,
  },

  // Auth
  ...authRoutes,

  //Dashboard
  withModulePermission('dashboard', dashboardRoutes),

  //contact
  withModulePermission('contact', contactRoutes),

  // account
  withModulePermission('company', accountRoutes),

  // chat
  withModulePermission('inbox', chatRoutes),
  // // form

  // campaign
  withModulePermission('campaign', campaignRoutes),

  // channel
  withModulePermission('channel', channelRoutes),

  // setting (each child route has its own PermissionWrapper)
  ...settingRoutes,

  // tenant
  withModulePermission('tenants', tenantRoutes),

  // ticket
  withModulePermission('ticket', ticketRoutes),

  //reports
  withModulePermission('report', reportRoutes),

  // CSAT & agent scores (CSAT.md)
  withModulePermission(['csat_analytics', 'csat_config'], csatRoutes),

  // automation
  withModulePermission(['workflow', 'ai_agents', 'ai_analytics'], automationRoutes),

  ...profileRoutes,

  // No match
  { path: '*', element: <Page404 /> },
  { path: '/policy', element: <PolicyPage /> },
  {
    path: '/403',
    element: (
      <AuthGuard>
        <Page403 />
      </AuthGuard>
    ),
  },
  {
    path: '/callback',
    element: <PaymentCallback />,
  },
  {
    path: '/calendar/success',
    element: (
      <AuthGuard>
        <PermissionWrapper module="calendar">
          <CalendarSuccess />
        </PermissionWrapper>
      </AuthGuard>
    ),
  },
];
